"use client";

import { useEffect, useState, ReactNode } from "react";
import Button from "../ui/Button";

interface SafeContactButtonProps {
  type: "mailto" | "tel";
  encodedValue: string;
  icon?: ReactNode;
  className?: string;
}

export default function SafeContactButton({
  type,
  encodedValue,
  icon,
  className
}: SafeContactButtonProps) {

  // initializes with a generic fallback to prevent hydration mismatches and obscure data during server-side rendering
  const [contact, setContact] = useState({ href: "#", text: "Kontakt laden..." });

  useEffect(() => {
    // decodes the Base64 string client-side to construct the valid href and display text
    const decoded = atob(encodedValue);
    setContact({
      href: `${type}:${decoded}`,
      text: decoded,
    });
  }, [encodedValue, type]);

  return (
    <Button className={className} variant="tertiary" href={contact.href} icon={icon}>
      {contact.text}
    </Button>
  );
}